import React, { Component } from 'react';
import { string } from 'prop-types';
import styled, { css } from 'styled-components';

const IconContainer = styled.span`
    color: ${({ color = '#000000' }) => color};
    font-size: ${({ size = 12 }) => size}px;
    ${({ top = '0', right = '0', bottom = '0', left = '0' }) => `
      margin: ${top}px ${right}px ${bottom}px ${left}px;
    `}
    ${({ pointer }) => pointer && css`
      cursor: pointer;
    `}
    ${({ cursor }) => cursor && css`
      cursor: ${cursor};
    `}
    ${({ zIndex }) => zIndex && css`
      z-index: ${zIndex};
    `}
`;

export default class Icon extends Component {
    static propTypes = {
        name: string
    }

    render () {
        const { name } = this.props;
        // Los íconos provienen del archivo selection.json ubicado en /static/
        return <IconContainer className={`icon-ic-${name}`} {...this.props} />;
    }
}
